import { useLogin } from "@/components/LoginModal";
import Tracker, { TrackerDiv } from "@/components/Tracker";
import { BuyVipDialog } from "@/components/Vip";
import useAppStore from "@/context/store";
import { gaodingEditUrl } from "@/pageComponents/GdMerge/shared";
import { Button } from "antd";
import classNames from "classnames";
import { useCallback, useEffect, useRef, useState } from "react";
import styles from "./index.module.less";
import VipInfo from "./vip";

// 吸顶头部
function MaterialHeaderSticky({ headerDom }) {
  const { login } = useLogin();

  const { headerHeight, wrapperWidth, user } = useAppStore(
    ({ headerHeight, wrapperWidth, user }) => ({
      headerHeight,
      wrapperWidth,
      user,
    })
  );

  const containerWidth = wrapperWidth >= 1296 ? 1296 : wrapperWidth;

  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const { bottom } = headerDom?.getBoundingClientRect();
      setShow(bottom - headerHeight <= 0);
    };
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [headerDom, headerHeight]);

  const onClick = useCallback(() => {
    if (!user) {
      login();
      return;
    }
    BuyVipDialog.open({
      page: "vipDetail",
      isGdDialog: true,
    });
  }, [user, login]);

  return (
    <div
      className={classNames([
        styles.sticky,
        "modalOpenWidth",
        show ? styles.show : null,
      ])}
    >
      <div className={styles.wrapper} style={{ width: `${containerWidth}px` }}>
        <div className={styles.left}>
          <div className={styles.img}>
            <img
              src="https://st0.dancf.com/static/02/202409090416-e1eb.png"
              alt="标题"
            />
          </div>
        </div>
        <div className={styles.right}>
          <Tracker
            component={Button}
            className={styles.button}
            type="primary"
            size="small"
            onClick={onClick}
            data-gd-click="resource_loc_click"
            data-gd-expose="resource_loc_expose"
            data-resource-type="文字链接"
            data-resource-id="0"
            data-resource-title="立即开通会员"
            data-content-source="吸顶"
          >
            立即开通会员
          </Tracker>
        </div>
      </div>
    </div>
  );
}

export default function MaterialHeader() {
  const headerRef = useRef(null);
  const { user } = useAppStore((store) => ({
    user: store.user,
  }));
  const [activeTab, setActiveTab] = useState<"image" | "font">("image");

  const handleTabClick = useCallback(
    (tab: "image" | "font") => {
      if (tab === "font") {
        // 点击字体tab，跳转到稿定字体页面
        const fontUrl = `${gaodingEditUrl}/material-font?from=huaban`;
        window.open(fontUrl, "_blank");
      } else {
        setActiveTab("image");
      }
    },
    [user]
  );

  return (
    <>
      <div className={styles.header} ref={headerRef}>
        <div className={styles.left}>
          <div className={styles.title}>
            <img
              src="https://st0.dancf.com/static/02/202409090401-2df2.png"
              alt="花瓣素材 让灵感到创造更简单"
            />
          </div>
          <div className={styles.subtitle}>
            127,358,260 高质量素材，商用0风险
          </div>
          <div className={styles.tabs}>
            <TrackerDiv
              className={classNames(styles.tab, {
                [styles.active]: activeTab === "image",
              })}
              onClick={() => handleTabClick("image")}
              data-gd-click="button_click"
              data-button-name="图片"
              data-content-source="花瓣素材首页"
            >
              图片
            </TrackerDiv>
            <TrackerDiv
              className={classNames(styles.tab, {
                [styles.active]: activeTab === "font",
              })}
              onClick={() => handleTabClick("font")}
              data-gd-click="button_click"
              data-button-name="字体"
              data-content-source="花瓣素材首页"
            >
              字体
              <img
                src="https://cdn.dancf.com/fe-assets/20260105/9e8627d20a70c61ed3f560dfd850304f.svg"
                alt="字体"
              />
            </TrackerDiv>
          </div>
        </div>
        <div className={styles.right}>
          <VipInfo />
        </div>
      </div>
    </>
  );
}
